import * as api from '../api/marketArea';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN';

export const SAVE_MARKET_AREA_TAGS = createRequestTypes(
  `${prefix}/SAVE_MARKET_AREA_TAGS`,
);

export const saveMarketAreaTags = makeApiActionCreatorV3(
  api.saveMarketAreaTags,
  SAVE_MARKET_AREA_TAGS[START],
  SAVE_MARKET_AREA_TAGS[SUCCESS],
  SAVE_MARKET_AREA_TAGS[ERROR],
);

export const FETCH_ALL_MARKET_AREA = createRequestTypes(
  `${prefix}/FETCH_ALL_MARKET_AREA`,
);

export const fetchAllMarketArea = makeApiActionCreatorV3(
  api.fetchAllMarketArea,
  FETCH_ALL_MARKET_AREA[START],
  FETCH_ALL_MARKET_AREA[SUCCESS],
  FETCH_ALL_MARKET_AREA[ERROR],
);

export const RESET_ALL_MARKET_AREA = `${prefix}/RESET_ALL_MARKET_AREA`;

export const resetAllMarketArea = () => ({
  type: RESET_ALL_MARKET_AREA,
});

export const INSERT_MARKET_AREA = createRequestTypes(
  `${prefix}/INSERT_MARKET_AREA`,
);

export const insertMarketArea = makeApiActionCreatorV3(
  api.insertMarketArea,
  INSERT_MARKET_AREA[START],
  INSERT_MARKET_AREA[SUCCESS],
  INSERT_MARKET_AREA[ERROR],
);

export const FETCH_MARKET_AREA = createRequestTypes(
  `${prefix}/FETCH_MARKET_AREA`,
);

export const fetchMarketArea = makeApiActionCreatorV3(
  api.fetchMarketArea,
  FETCH_MARKET_AREA[START],
  FETCH_MARKET_AREA[SUCCESS],
  FETCH_MARKET_AREA[ERROR],
);

export const RESET_MARKET_AREA = `${prefix}/RESET_MARKET_AREA`;

export const resetMarketArea = () => ({
  type: RESET_MARKET_AREA,
});

export const SET_MARKET_AREA_YEAR_FILTER = `${prefix}/SET_MARKET_AREA_YEAR_FILTER`;

export const setMarketAreaYear = (year) => ({
  type: SET_MARKET_AREA_YEAR_FILTER,
  payload: year,
});

export const UPDATE_MARKET_AREA = createRequestTypes(
  `${prefix}/UPDATE_MARKET_AREA`,
);

export const updateMarketArea = makeApiActionCreatorV3(
  api.updateMarketArea,
  UPDATE_MARKET_AREA[START],
  UPDATE_MARKET_AREA[SUCCESS],
  UPDATE_MARKET_AREA[ERROR],
);

export const FETCH_MARKET_AREA_DETAILS = createRequestTypes(
  `${prefix}/FETCH_MARKET_AREA_DETAILS`,
);

export const fetchMarketAreaDetails = makeApiActionCreatorV3(
  api.fetchMarketAreaDetails,
  FETCH_MARKET_AREA_DETAILS[START],
  FETCH_MARKET_AREA_DETAILS[SUCCESS],
  FETCH_MARKET_AREA_DETAILS[ERROR],
);

export const DELETE_MARKET_AREA_DETAIL = createRequestTypes(
  `${prefix}/DELETE_MARKET_AREA_DETAIL`,
);

export const deleteMarketAreaDetail = makeApiActionCreatorV3(
  api.deleteMarketAreaDetail,
  DELETE_MARKET_AREA_DETAIL[START],
  DELETE_MARKET_AREA_DETAIL[SUCCESS],
  DELETE_MARKET_AREA_DETAIL[ERROR],
);

export const INSERT_MARKET_AREA_FILE = createRequestTypes(
  `${prefix}/INSERT_MARKET_AREA_FILE`,
);

export const insertMarketAreaFile = makeApiActionCreatorV3(
  api.insertMarketAreaFile,
  INSERT_MARKET_AREA_FILE[START],
  INSERT_MARKET_AREA_FILE[SUCCESS],
  INSERT_MARKET_AREA_FILE[ERROR],
);

export const DELETE_MARKET_AREA_FILE = createRequestTypes(
  `${prefix}/DELETE_MARKET_AREA_FILE`,
);

export const deleteMarketAreaFile = makeApiActionCreatorV3(
  api.deleteMarketAreaFile,
  DELETE_MARKET_AREA_FILE[START],
  DELETE_MARKET_AREA_FILE[SUCCESS],
  DELETE_MARKET_AREA_FILE[ERROR],
);

export const DOWNLOAD_MARKET_AREA_FILE = createRequestTypes(
  `${prefix}/DOWNLOAD_MARKET_AREA_FILE`,
);

export const downloadMarketAreaFile = makeApiActionCreatorV3(
  api.downloadMarketAreaFile,
  DOWNLOAD_MARKET_AREA_FILE[START],
  DOWNLOAD_MARKET_AREA_FILE[SUCCESS],
  DOWNLOAD_MARKET_AREA_FILE[ERROR],
);

export const UPDATE_MARKET_AREA_FILE = createRequestTypes(
  `${prefix}/UPDATE_MARKET_AREA_FILE`,
);

export const updateMarketAreaFile = makeApiActionCreatorV3(
  api.updateMarketAreaFile,
  UPDATE_MARKET_AREA_FILE[START],
  UPDATE_MARKET_AREA_FILE[SUCCESS],
  UPDATE_MARKET_AREA_FILE[ERROR],
);

export const INSERT_MARKET_AREA_DETAIL = createRequestTypes(
  `${prefix}/INSERT_MARKET_AREA_DETAIL`,
);

export const insertMarketAreaDetail = makeApiActionCreatorV3(
  api.insertMarketAreaDetail,
  INSERT_MARKET_AREA_DETAIL[START],
  INSERT_MARKET_AREA_DETAIL[SUCCESS],
  INSERT_MARKET_AREA_DETAIL[ERROR],
);

export const FETCH_MARKET_AREA_DETAIL = createRequestTypes(
  `${prefix}/FETCH_MARKET_AREA_DETAIL`,
);

export const fetchMarketAreaDetail = makeApiActionCreatorV3(
  api.fetchMarketAreaDetail,
  FETCH_MARKET_AREA_DETAIL[START],
  FETCH_MARKET_AREA_DETAIL[SUCCESS],
  FETCH_MARKET_AREA_DETAIL[ERROR],
);

export const UPDATE_MARKET_AREA_DETAIL = createRequestTypes(
  `${prefix}/UPDATE_MARKET_AREA_DETAIL`,
);

export const updateMarketAreaDetail = makeApiActionCreatorV3(
  api.updateMarketAreaDetail,
  UPDATE_MARKET_AREA_DETAIL[START],
  UPDATE_MARKET_AREA_DETAIL[SUCCESS],
  UPDATE_MARKET_AREA_DETAIL[ERROR],
);

export const INSERT_MARKET_AREA_DETAIL_FILE = createRequestTypes(
  `${prefix}/INSERT_MARKET_AREA_DETAIL_FILE`,
);

export const insertMarketAreaDetailFile = makeApiActionCreatorV3(
  api.insertMarketAreaDetailFile,
  INSERT_MARKET_AREA_DETAIL_FILE[START],
  INSERT_MARKET_AREA_DETAIL_FILE[SUCCESS],
  INSERT_MARKET_AREA_DETAIL_FILE[ERROR],
);

export const DELETE_MARKET_AREA_DETAIL_FILE = createRequestTypes(
  `${prefix}/DELETE_MARKET_AREA_DETAIL_FILE`,
);

export const deleteMarketAreaDetailFile = makeApiActionCreatorV3(
  api.deleteMarketAreaDetailFile,
  DELETE_MARKET_AREA_DETAIL_FILE[START],
  DELETE_MARKET_AREA_DETAIL_FILE[SUCCESS],
  DELETE_MARKET_AREA_DETAIL_FILE[ERROR],
);

export const DOWNLOAD_MARKET_AREA_DETAIL_FILE = createRequestTypes(
  `${prefix}/DOWNLOAD_MARKET_AREA_DETAIL_FILE`,
);

export const downloadMarketAreaDetailFile = makeApiActionCreatorV3(
  api.downloadMarketAreaDetailFile,
  DOWNLOAD_MARKET_AREA_DETAIL_FILE[START],
  DOWNLOAD_MARKET_AREA_DETAIL_FILE[SUCCESS],
  DOWNLOAD_MARKET_AREA_DETAIL_FILE[ERROR],
);

export const UPDATE_MARKET_AREA_DETAIL_FILE = createRequestTypes(
  `${prefix}/UPDATE_MARKET_AREA_DETAIL_FILE`,
);

export const updateMarketAreaDetailFile = makeApiActionCreatorV3(
  api.updateMarketAreaDetailFile,
  UPDATE_MARKET_AREA_DETAIL_FILE[START],
  UPDATE_MARKET_AREA_DETAIL_FILE[SUCCESS],
  UPDATE_MARKET_AREA_DETAIL_FILE[ERROR],
);

export const FETCH_MARKET_AREA_USE_CODES = createRequestTypes(
  `${prefix}/FETCH_MARKET_AREA_USE_CODES`,
);

export const fetchMarketAreaUseCodes = makeApiActionCreatorV3(
  api.fetchMarketAreaUseCodes,
  FETCH_MARKET_AREA_USE_CODES[START],
  FETCH_MARKET_AREA_USE_CODES[SUCCESS],
  FETCH_MARKET_AREA_USE_CODES[ERROR],
);

export const INSERT_MARKET_AREA_USE_CODES = createRequestTypes(
  `${prefix}/INSERT_MARKET_AREA_USE_CODES`,
);

export const insertMarketAreaUseCodes = makeApiActionCreatorV3(
  api.insertMarketAreaUseCodes,
  INSERT_MARKET_AREA_USE_CODES[START],
  INSERT_MARKET_AREA_USE_CODES[SUCCESS],
  INSERT_MARKET_AREA_USE_CODES[ERROR],
);

export const DELETE_MARKET_AREA_USE_CODES = createRequestTypes(
  `${prefix}/DELETE_MARKET_AREA_USE_CODES`,
);

export const deleteMarketAreaUseCode = makeApiActionCreatorV3(
  api.deleteMarketAreaUseCode,
  DELETE_MARKET_AREA_USE_CODES[START],
  DELETE_MARKET_AREA_USE_CODES[SUCCESS],
  DELETE_MARKET_AREA_USE_CODES[ERROR],
);

export const CHANGE_SORT_MODEL = `${prefix}/CHANGE_SORT_MODEL`;

export const changeSortModel = (model) => ({
  type: CHANGE_SORT_MODEL,
  payload: model,
});
